import React from "react";
import styled from "styled-components";
import { FontSize } from "@glossy";
import { content } from "@glossy/theme";
import SafeHTML from "@ui-kit/safe-html";

interface IProps {
  // Modal title
  title?: string | React.ReactNode;
}

const Title = styled.div`
  color: ${content};
  font-size: ${FontSize.Large};
`;

const UiKitModalTitle = ({ title }: IProps) => (
  <>
    {!!title && typeof title === "string" ? (
      <SafeHTML as={Title} html={title} />
    ) : (
      <Title>{title}</Title>
    )}
  </>
);

export default UiKitModalTitle;
